module.exports = __webpack_public_path__ + "media/img/about/social/pinterest-ce16bae8162626f4e499e8f3daca0c07.png";